/**
 * This client was automatically generated by RudderTyper. ** Do Not Edit **
 */
let analytics = () => {
    return window.rudderanalytics;
};
/**
 * Updates the run-time configuration of this RudderTyper client.
 *
 * @param {RudderTyperOptions} options - the options to upsert
 *
 * @typedef {Object} RudderTyperOptions
 * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setRudderTyperOptions(options) {
    analytics = options.analytics
        ? () => options.analytics || window.rudderanalytics
        : analytics;
}
/**
 * Helper to attach metadata on RudderTyper to outbound requests.
 * This is used for attribution and debugging by the RudderStack team.
 */
function withRudderTyperContext(message = {}) {
    return {
        ...message,
        context: {
            ...(message.context || {}),
            ruddertyper: {
                sdk: 'analytics.js',
                language: 'typescript',
                rudderTyperVersion: '1.7.3',
                trackingPlanId: 'tp_2x8qxmzWKqReGJGJMFzvUe4goox',
                trackingPlanVersion: 90,
            },
        },
    };
}
/**
 * @typedef BookingAppointmentStarted
 * @property {string} [executed_by] -
 * @property {string} [stage] -
 * @property {number} [step] -
 * @property {string} [widget_version] -
 */
/**
 * @typedef CartItemAdded
 * @property {number} [customer_id] -
 * @property {any | null} [item_id] -
 * @property {string} [item_name] -
 * @property {number} [pow_user_id] -
 * @property {number} [price] -
 * @property {any | null} [purchasable_item_id] -
 * @property {number} [quantity] -
 */
/**
 * @typedef CartItemDeleted
 * @property {number} [customer_id] -
 * @property {number} [pow_user_id] -
 */
/**
 * @typedef CartItemEdited
 * @property {any | null} [item_id] -
 * @property {number} [new_quantity] -
 * @property {number} [old_quantity] -
 * @property {number} [pow_user_id] -
 * @property {any | null} [purchasable_item_id] -
 */
/**
 * @typedef CcCollected
 * @property {string} [executed_by] -
 */
/**
 * @typedef DobCollected
 * @property {string} [executed_by] -
 */
/**
 * @typedef SplitTestAssignment
 * @property {number} [customer_id] -
 * @property {string} [executed_by] -
 * @property {any | null} [experiment_id] -
 * @property {number} [variant_id] -
 * @property {string} [variant_name] -
 */
/**
 * @typedef Page
 * @property {string} [executed_by] -
 * @property {string} [fbclid] -
 * @property {string} [gclid] -
 */
/**
 * @typedef Identify
 * @property {string} [address] -
 * @property {number} [age] -
 * @property {number} customer_id -
 * @property {string | null} date_of_birth -
 * @property {string} [email] -
 * @property {string} [first_name] -
 * @property {string | null} [gender] -
 * @property {string} [last_name] -
 * @property {string} [phone_number] -
 */
/**
 * User enters widget booking flow
 *
 * @param {BookingAppointmentStarted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function bookingAppointmentStarted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('booking_appointment_started', props || {}, withRudderTyperContext(options), callback);
    }
}
/**
 * Fires a 'cart_item_added' track call.
 *
 * @param {CartItemAdded} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function cartItemAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('cart_item_added', props || {}, withRudderTyperContext(options), callback);
    }
}
/**
 * Fires a 'cart_item_deleted' track call.
 *
 * @param {CartItemDeleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function cartItemDeleted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('cart_item_deleted', props || {}, withRudderTyperContext(options), callback);
    }
}
/**
 * Fires a 'cart_item_edited' track call.
 *
 * @param {CartItemEdited} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function cartItemEdited(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('cart_item_edited', props || {}, withRudderTyperContext(options), callback);
    }
}
/**
 * Credit Card information is collected
 *
 * @param {CcCollected} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function ccCollected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('cc_collected', props || {}, withRudderTyperContext(options), callback);
    }
}
/**
 * Date of Birth is collected
 *
 * @param {DobCollected} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dobCollected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('dob_collected', props || {}, withRudderTyperContext(options), callback);
    }
}
/**
 * User is assigned a variant
 *
 * @param {SplitTestAssignment} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function splitTestAssignment(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('split_test_assignment', props || {}, withRudderTyperContext(options), callback);
    }
}
export function page(categoryOrProps, nameOrPropsOrOptions, propsOrOptionsOrCallback, optionsOrCallback, callback) {
    const a = analytics();
    if (a) {
        if (typeof categoryOrProps === 'string' &&
            typeof nameOrPropsOrOptions === 'string') {
            // Overload (category: string, name: string, props?: Page, options?: ApiOptions, callback?: apiCallback)
            a.page(categoryOrProps, 'page', propsOrOptionsOrCallback || {}, withRudderTyperContext(optionsOrCallback), callback);
        }
        else if (typeof categoryOrProps === 'string') {
            // Overload (name: string, props?: Page, options?: ApiOptions, callback?: apiCallback)
            a.page('page', nameOrPropsOrOptions || {}, withRudderTyperContext(propsOrOptionsOrCallback), optionsOrCallback);
        }
        else {
            // Overload (props?: Page, options?: ApiOptions, callback?: apiCallback)
            a.page(categoryOrProps || {}, withRudderTyperContext(nameOrPropsOrOptions), propsOrOptionsOrCallback);
        }
    }
}
export function identify(userIdOrTraits, traitsOrOptions, optionsOrCallback, callback) {
    const a = analytics();
    if (a) {
        const userId = typeof userIdOrTraits === 'string' ? userIdOrTraits : undefined;
        const traits = typeof userIdOrTraits === 'string'
            ? traitsOrOptions
            : userIdOrTraits;
        const options = typeof userIdOrTraits === 'string'
            ? optionsOrCallback
            : traitsOrOptions;
        const cb = typeof userIdOrTraits === 'string'
            ? callback
            : optionsOrCallback;
        a.identify(userId, traits || {}, withRudderTyperContext(options), cb);
    }
}
const clientAPI = {
    /**
     * Updates the run-time configuration of this RudderTyper client.
     *
     * @param {RudderTyperOptions} options - the options to upsert
     *
     * @typedef {Object} RudderTyperOptions
     * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
     * 		calls are forwarded on to. Defaults to window.analytics.
     * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
     * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
     * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
     * 		will be logged to stderr.
     */
    setRudderTyperOptions,
    /**
     * User enters widget booking flow
     *
     * @param {BookingAppointmentStarted} [props] - The analytics properties that will be sent to RudderStack.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
     */
    bookingAppointmentStarted,
    /**
     * Fires a 'cart_item_added' track call.
     *
     * @param {CartItemAdded} [props] - The analytics properties that will be sent to RudderStack.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
     */
    cartItemAdded,
    /**
     * Fires a 'cart_item_deleted' track call.
     *
     * @param {CartItemDeleted} [props] - The analytics properties that will be sent to RudderStack.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
     */
    cartItemDeleted,
    /**
     * Fires a 'cart_item_edited' track call.
     *
     * @param {CartItemEdited} [props] - The analytics properties that will be sent to RudderStack.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
     */
    cartItemEdited,
    /**
     * Credit Card information is collected
     *
     * @param {CcCollected} [props] - The analytics properties that will be sent to RudderStack.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
     */
    ccCollected,
    /**
     * Date of Birth is collected
     *
     * @param {DobCollected} [props] - The analytics properties that will be sent to RudderStack.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
     */
    dobCollected,
    /**
     * User is assigned a variant
     *
     * @param {SplitTestAssignment} [props] - The analytics properties that will be sent to RudderStack.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
     */
    splitTestAssignment,
    /**
     * Fired when a page is viewed
     *
     * @param {string} [category] - The category of the page.
     * @param {string} [name] - The name of the page.
     * @param {Page} [props] - The analytics properties that will be sent to RudderStack.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
     */
    page,
    /**
     * Identify customer traits
     *
     * @param {string} [userId] - The user ID of the user.
     * @param {Identify} [traits] - The analytics traits that will be sent to RudderStack.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
     */
    identify,
};
export const RudderTyperAnalytics = new Proxy(clientAPI, {
    get(target, method) {
        if (typeof method === 'string' && Object.keys(target).includes(method)) {
            return target[method];
        }
        return () => {
            const a = analytics();
            if (a) {
                a.track('Unknown Analytics Call Fired', {
                    method,
                }, withRudderTyperContext());
            }
        };
    },
});
